import React from 'react';
import AddRuleItem from './AddRuleItem';

class Rule extends React.Component {
    constructor(props) {
        super(props);
    }

  

    render() {
        if(this.props.onlyDescription) {
            return <AddRuleItem select={this.props.addRule} value="true" operator="==" action="Who" ruleKey={this.props.ruleKey} title="Leaving customers" description="Only show to customers who are about to leave" />
        }
        return (
                <div className="list-group-item blue-grey-500">    
                    <i className="icon wb-arrow-right" aria-hidden="true"></i>
                    Display to visitors who are about to leave your shop.
                    <div className="remove-rule"><a href="javascript:void(0)" onClick={e => {e.stopPropagation(); this.props.handleRemove(this.props.rule.id)}}><i className="icon wb-close"></i></a></div>
                </div>
        );
    }

  
}

export default Rule;




// WEBPACK FOOTER //
// ./components/builder/RuleShowToLeaving.js